var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _g3, _path38, _path39, _path40, _g4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g5, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g6, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyonWhatsapp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 167,
    viewBox: "0 0 192 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6359_86497)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4885 161.285C42.4885 161.285 64.8393 172.904 90.383 160.655C115.927 148.406 124.241 124.654 137.476 106.834C144.419 97.4948 155.777 92.2918 164.443 84.4401C192.146 59.3293 182.143 17.3493 156.805 5.82896C134.857 -4.14422 109.506 -0.569817 78.0954 16.3122C46.6844 33.1941 24.0508 44.0931 7.55883 77.737C-8.93314 111.381 14.6991 145.004 42.4885 161.285Z",
    fill: "#219EBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.4885 161.285C42.4885 161.285 64.8393 172.904 90.383 160.655C115.927 148.406 124.241 124.654 137.476 106.834C144.419 97.4948 155.777 92.2918 164.443 84.4401C192.146 59.3293 182.143 17.3493 156.805 5.82896C134.857 -4.14422 109.506 -0.569817 78.0954 16.3122C46.6844 33.1941 24.0508 44.0931 7.55883 77.737C-8.93314 111.381 14.6991 145.004 42.4885 161.285Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 132.545H177.734",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 99.8398H177.734",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 67.1338H177.734",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 34.4268H177.734",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2656 15.8584V132.622",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.094 15.8584V132.622",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1295 59.1406L46.8438 60.4949",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0211 36.0479L49.6719 57.5071",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2898 39.542L59.8594 51.2895",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.544 59.1406L151.258 60.4949",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.431 36.0479L154.086 57.5071",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.704 39.542L164.273 51.2895",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40294 125.186L1.11719 126.54",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2903 102.088L3.94531 123.551",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5675 105.582L14.1328 117.334",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2346 31.2012L17.9531 32.5555",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1262 8.10449L20.7812 29.5638",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3913 11.5967L30.9609 23.3442",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.375 31.2012L113.094 32.5555",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.275 8.10449L115.93 29.5638",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.54 11.5967L126.109 23.3442",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9576 93.1152L83.6719 94.4696",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.853 70.0234L86.5078 91.4827",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.118 73.5156L96.6875 85.2632",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M172.677 156.711C172.677 156.711 162.065 134.099 164.371 133.448C166.677 132.796 171.511 136.396 171.511 136.396C171.511 136.396 157.325 98.3809 160.998 95.4322C164.671 92.4835 171.528 107.574 171.528 107.574C171.528 107.574 164.204 84.289 165.065 75.4301C165.927 66.5712 175.231 75.1044 175.231 75.1044C175.231 75.1044 167.778 43.3162 174.7 41.6747C181.622 40.0332 181.39 78.0488 181.39 78.0488C181.39 78.0488 183.662 50.8464 186.435 58.3853C189.207 65.9241 183.379 91.1549 183.379 91.1549C183.379 91.1549 187.18 82.6346 189.293 90.4992C191.406 98.3637 185.093 130.152 185.093 130.152C185.093 130.152 190.459 124.91 190.96 131.463C191.462 138.016 179.851 158.336 179.851 158.336L173.281 159.004L172.677 156.711Z",
    fill: "#219EBC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M172.677 156.711C172.677 156.711 162.065 134.099 164.371 133.448C166.677 132.796 171.511 136.396 171.511 136.396C171.511 136.396 157.325 98.3809 160.998 95.4322C164.671 92.4835 171.528 107.574 171.528 107.574C171.528 107.574 164.204 84.289 165.065 75.4301C165.927 66.5712 175.231 75.1044 175.231 75.1044C175.231 75.1044 167.778 43.3162 174.7 41.6747C181.622 40.0332 181.39 78.0488 181.39 78.0488C181.39 78.0488 183.662 50.8464 186.435 58.3853C189.207 65.9241 183.379 91.1549 183.379 91.1549C183.379 91.1549 187.18 82.6346 189.293 90.4992C191.406 98.3637 185.093 130.152 185.093 130.152C185.093 130.152 190.459 124.91 190.96 131.463C191.462 138.016 179.851 158.336 179.851 158.336L173.281 159.004L172.677 156.711Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M174.94 157.719C174.94 157.719 166.094 141.99 167.731 139.037C169.368 136.084 174.284 142.971 174.284 142.971C174.284 142.971 163.141 115.113 164.782 112.494C166.424 109.876 171.665 121.345 171.665 121.345C171.665 121.345 169.698 83.0035 172.972 84.3107C176.247 85.6179 176.564 103.953 176.564 103.953C176.564 103.953 174.601 60.3699 177.55 61.6814C180.498 62.9928 180.173 111.492 180.173 111.492C180.173 111.492 186.07 92.8095 187.052 101.33C188.033 109.85 179.517 132.792 179.517 132.792C179.517 132.792 187.707 114.766 188.706 124.289C189.704 133.812 182.136 151.47 182.136 151.47C182.136 151.47 185.084 144.261 185.084 148.191C185.084 152.121 182.791 157.042 182.791 157.042",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.607 108.964L162.543 135.013L155.034 137.131L146.18 126.107L150.607 108.964Z",
    fill: "#219EBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6359_86497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 108,
    width: 17,
    height: 30
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.607 108.964L162.543 135.013L155.034 137.131L146.18 126.107L150.607 108.964Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6359_86497)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.451 117.305L147.945 119.272L157.858 136.334L159.281 135.935L148.451 117.305Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.089 137.118L156.521 136.715L147.298 121.771L146.805 123.686L155.089 137.118Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.679 112.561L149.156 114.592L160.539 135.58L161.945 135.181L149.679 112.561Z",
    fill: "#0E1213"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.607 108.964L162.543 135.013L155.034 137.131L146.18 126.107L150.607 108.964Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.865 101.707L111.32 108.869L119.609 142.5L116.969 156.647H146.46L143.541 141.274L150.699 108.963L134.4 102.273L126.865 101.707Z",
    fill: "#219EBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6359_86497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 101,
    width: 40,
    height: 56
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M126.865 101.709L111.32 108.871L119.609 142.502L116.969 156.649H146.46L143.541 141.276L150.699 108.965L134.4 102.275L126.865 101.709Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6359_86497)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.007 156.648L127.603 143.25C127.609 143.187 127.609 143.124 127.603 143.062L121.495 104.185L119.695 105.012L125.696 143.263L125.1 156.648H127.007Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.578 140.044C130.578 140.044 130.578 140.01 130.578 139.993L125.735 102.226L123.922 103.083L128.679 140.228L129.905 156.669H131.816L130.578 140.044Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.617 156.648L123.331 143.571C123.346 143.475 123.346 143.377 123.331 143.28L116.795 106.357L115.008 107.18L121.437 143.469L119.722 156.648H121.617Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.02 108.685L148.224 107.948L141.671 141.836C141.651 141.947 141.651 142.06 141.671 142.171L144.028 156.648H145.961L143.565 142.034L143.621 141.755L143.526 141.275L144.962 134.808L150.02 108.685Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.848 105.557L130.945 105.612L132.527 156.648H134.43L132.848 105.557Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.524 141.785L145.854 106.975L144.054 106.233L137.625 141.609C137.604 141.718 137.604 141.83 137.625 141.939L140.137 156.648H142.07L139.524 141.785Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.067 140.601L140.88 104.93L139.059 104.185L134.164 140.464C134.154 140.541 134.154 140.619 134.164 140.696L135.938 156.648H137.854L136.067 140.601Z",
    fill: "#0E1213"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M126.865 101.707L111.32 108.869L119.609 142.5L116.969 156.647H146.46L143.541 141.274L150.699 108.963L134.4 102.273L126.865 101.707Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 108.869L99.0781 135.386L106.896 137.036L115.75 126.013L111.323 108.869Z",
    fill: "#219EBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6359_86497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 108,
    width: 17,
    height: 30
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 108.87L99.0781 135.387L106.896 137.037L115.75 126.014L111.323 108.87Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6359_86497)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.544 121.333L106.016 136.852L106.899 137.036L108.939 134.495L115.063 123.352L114.544 121.333Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.771 118.366L113.214 116.206L103.695 136.362L105.131 136.667L113.771 118.366Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.594 135.703L102.03 136.007L112.56 113.648L111.998 111.479L100.594 135.703Z",
    fill: "#0E1213"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.002 113.282L115.322 124.875L110.984 118.237",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M111.323 108.869L99.0781 135.386L106.896 137.036L115.75 126.013L111.323 108.869Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M107.459 133.079L122.91 150.698L119.91 154.088L100.439 138.582C100.439 138.582 97.7688 137.296 99.3717 134.682",
    fill: "#219EBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6359_86497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 133,
    width: 25,
    height: 22
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.459 133.078L122.91 150.697L119.91 154.087L100.439 138.581C100.439 138.581 97.7688 137.295 99.3717 134.681",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6359_86497)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.29 151.923L122.739 150.684L114.947 141.616L107.46 133.078L105.445 133.477L121.29 151.923Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.203 152.737L119.493 153.766L120.706 152.698L104.043 133.755L101.883 134.179L118.203 152.737Z",
    fill: "#0E1213"
  })))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.459 133.079L122.91 150.698L119.91 154.088L100.439 138.582C100.439 138.582 97.7688 137.296 99.3717 134.682",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.428 150.034C120.857 149.794 128.31 148.011 128.413 148.924C128.515 149.837 130.735 150.844 131.747 150.844C132.758 150.844 133.77 150.034 133.971 151.247C134.173 152.46 133.063 152.563 132.154 152.661C131.245 152.76 128.108 151.753 128.108 151.753C128.108 151.753 125.177 154.179 123.964 154.783C122.751 155.387 120.535 155.212 119.721 154.581C118.906 153.951 117.805 151.449 120.428 150.034Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.305 148.821C127.305 148.821 130.133 148.011 130.733 148.315C131.333 148.62 131.646 154.684 131.646 154.684C131.646 154.684 131.342 155.289 130.733 154.684C130.125 154.08 128.106 149.541 128.106 149.541",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M127.305 148.821C127.305 148.821 130.133 148.011 130.733 148.315C131.333 148.62 131.646 154.684 131.646 154.684C131.646 154.684 131.342 155.289 130.733 154.684C130.125 154.08 128.106 149.541 128.106 149.541",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M125.887 149.024C125.887 149.024 128.819 148.317 129.427 149.427C130.036 150.537 131.549 155.491 130.336 155.697C129.123 155.903 128.72 154.278 128.72 154.278L126.8 150.742L125.484 150.541",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M125.887 149.024C125.887 149.024 128.819 148.317 129.427 149.427C130.036 150.537 131.549 155.491 130.336 155.697C129.123 155.903 128.72 154.278 128.72 154.278L126.8 150.742L125.484 150.541",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.875 149.932C124.875 149.932 126.289 149.328 126.996 149.834C127.704 150.339 130.939 155.491 130.331 155.697C129.722 155.902 128.308 155.795 128.107 155.392C127.905 154.99 125.278 151.535 125.278 151.535",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.875 149.932C124.875 149.932 126.289 149.328 126.996 149.834C127.704 150.339 130.939 155.491 130.331 155.697C129.722 155.902 128.308 155.795 128.107 155.392C127.905 154.99 125.278 151.535 125.278 151.535",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M123.859 151.651C123.859 151.651 125.171 150.438 125.878 150.845C126.585 151.252 129.517 155.088 128.912 155.491C128.308 155.894 127.901 155.491 127.297 154.685C126.863 154.142 126.352 153.665 125.779 153.271L124.567 153.674",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M123.859 151.651C123.859 151.651 125.171 150.438 125.878 150.845C126.585 151.252 129.517 155.088 128.912 155.491C128.308 155.894 127.901 155.491 127.297 154.685C126.863 154.142 126.352 153.665 125.779 153.271L124.567 153.674",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M153.721 133.646L148.578 151.145L152.298 153.742L160.703 140.233C160.703 140.233 164.157 136.333 161.989 134.138",
    fill: "#219EBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6359_86497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 133,
    width: 15,
    height: 21
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M153.721 133.646L148.578 151.145L152.298 153.742L160.703 140.233C160.703 140.233 164.157 136.333 161.989 134.138",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6359_86497)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.411 153.531L152.475 153.424L159.594 133.996L157.605 133.876L150.727 152.657L151.498 153.192L152.411 153.531Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.586 151.156L150.202 152.288L156.845 133.884L156.66 133.82L154.882 133.713L148.586 151.156Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.573 135.161C162.46 134.774 162.25 134.422 161.965 134.137L160.945 134.077L155.57 148.473L160.679 140.253L162.573 135.161Z",
    fill: "#0E1213"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M153.721 133.646L148.578 151.145L152.298 153.742L160.703 140.233C160.703 140.233 164.157 136.333 161.989 134.138",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M151.169 150.034C150.74 149.794 143.283 148.011 143.184 148.924C143.086 149.837 140.857 150.844 139.85 150.844C138.843 150.844 137.827 150.034 137.626 151.247C137.424 152.46 138.534 152.563 139.443 152.661C140.351 152.76 143.489 151.753 143.489 151.753C143.489 151.753 146.42 154.179 147.633 154.783C148.846 155.387 151.062 155.212 151.876 154.581C152.69 153.951 153.796 151.449 151.169 150.034Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 148.821C144.29 148.821 141.462 148.011 140.862 148.315C140.262 148.62 139.953 154.684 139.953 154.684C139.953 154.684 140.257 155.289 140.862 154.684C141.466 154.08 143.493 149.541 143.493 149.541",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 148.821C144.29 148.821 141.462 148.011 140.862 148.315C140.262 148.62 139.953 154.684 139.953 154.684C139.953 154.684 140.257 155.289 140.862 154.684C141.466 154.08 143.493 149.541 143.493 149.541",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M145.716 149.024C145.716 149.024 142.789 148.317 142.18 149.427C141.572 150.537 140.037 155.491 141.272 155.697C142.506 155.903 142.887 154.278 142.887 154.278L144.808 150.742L146.123 150.541",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M145.716 149.024C145.716 149.024 142.789 148.317 142.18 149.427C141.572 150.537 140.037 155.491 141.272 155.697C142.506 155.903 142.887 154.278 142.887 154.278L144.808 150.742L146.123 150.541",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M146.719 149.932C146.719 149.932 145.305 149.328 144.598 149.834C143.891 150.339 140.655 155.491 141.263 155.697C141.872 155.902 143.282 155.795 143.488 155.392C143.693 154.99 146.316 151.535 146.316 151.535",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M146.719 149.932C146.719 149.932 145.305 149.328 144.598 149.834C143.891 150.339 140.655 155.491 141.263 155.697C141.872 155.902 143.282 155.795 143.488 155.392C143.693 154.99 146.316 151.535 146.316 151.535",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M147.728 151.651C147.728 151.651 146.417 150.433 145.714 150.862C145.011 151.291 142.075 155.105 142.684 155.508C143.293 155.911 143.696 155.508 144.3 154.702C144.733 154.159 145.245 153.682 145.817 153.288L147.03 153.691",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M147.728 151.651C147.728 151.651 146.417 150.433 145.714 150.862C145.011 151.291 142.075 155.105 142.684 155.508C143.293 155.911 143.696 155.508 144.3 154.702C144.733 154.159 145.245 153.682 145.817 153.288L147.03 153.691",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M127.995 99.9145C127.995 99.9145 125.548 100.669 124.51 102.177C123.473 103.686 124.699 115.365 124.699 115.365L132.521 111.032L140.715 116.214C140.715 116.214 139.961 104.252 139.301 102.555C138.641 100.857 134.496 98.8816 133.082 99.0701C131.668 99.2587 127.995 99.9145 127.995 99.9145Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.875 93.4185V104.253L132.057 118.195L136.484 103.97V93.3242L126.875 93.4185Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.859 97.3101C128.322 98.3363 130.066 98.8856 131.852 98.883C133.486 98.8843 135.086 98.4237 136.468 97.5544V93.3242L126.859 93.4314V97.3101Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M131.863 96.4303C129.548 96.4303 127.328 95.5111 125.691 93.8748C124.054 92.2384 123.134 90.019 123.132 87.7043L121.594 75.4296C121.594 72.7016 122.677 70.0853 124.606 68.1563C126.535 66.2273 129.152 65.1436 131.88 65.1436C134.608 65.1436 137.224 66.2273 139.153 68.1563C141.082 70.0853 142.166 72.7016 142.166 75.4296L140.572 87.6872C140.574 88.8331 140.35 89.9682 139.914 91.0278C139.477 92.0873 138.837 93.0505 138.028 93.8624C137.219 94.6743 136.258 95.3189 135.201 95.7595C134.143 96.2001 133.009 96.428 131.863 96.4303Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M134.102 84.3456C134.102 84.3456 136.326 82.4813 138.983 84.4914",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.084 84.1316C129.423 83.711 128.637 83.5337 127.859 83.6302",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M134.969 79.8961C134.969 79.8961 137.339 78.7475 138.775 80.9718",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M131.141 89.2998C131.141 89.2998 132.148 90.0884 133.009 89.2998",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M130.156 91.0234C130.156 91.0234 132.239 92.3092 133.456 91.0234",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M136.252 74.1446C136.252 74.1446 127.646 82.0906 125.246 87.8808C122.846 93.671 124.998 99.7183 126.322 101.458C127.646 103.198 128.465 103.443 128.465 103.443C128.465 103.443 123.913 105.183 120.935 100.631C117.956 96.0796 118.697 90.9452 119.61 87.3879C120.523 83.8307 120.27 73.3989 122.34 69.9231C124.41 66.4472 127.389 63.88 132.356 64.4586C137.324 65.0372 139.968 67.6044 141.541 70.8317C143.114 74.0589 142.368 79.5234 142.865 81.9235C143.362 84.3235 145.514 91.5238 146.011 95.8268C146.508 100.13 140.641 103.194 139.715 103.61C139.086 103.874 138.413 104.02 137.731 104.038C137.731 104.038 139.715 94.1081 140.131 88.3951C140.547 82.6821 140.572 79.2877 140.572 79.2877C140.572 79.2877 136.668 74.3932 136.252 74.1446Z",
    fill: "#0E1213"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6359_86497",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 64,
    width: 29,
    height: 41
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M136.252 74.1437C136.252 74.1437 127.646 82.0896 125.246 87.8798C122.846 93.67 124.998 99.7174 126.322 101.457C127.646 103.197 128.465 103.442 128.465 103.442C128.465 103.442 123.913 105.182 120.935 100.63C117.956 96.0787 118.697 90.9442 119.61 87.3869C120.523 83.8297 120.27 73.3979 122.34 69.9221C124.41 66.4463 127.389 63.879 132.356 64.4576C137.324 65.0362 139.968 67.6034 141.541 70.8307C143.114 74.0579 142.368 79.5224 142.865 81.9225C143.362 84.3226 145.514 91.5228 146.011 95.8258C146.508 100.129 140.641 103.193 139.715 103.609C139.086 103.874 138.413 104.019 137.731 104.037C137.731 104.037 139.715 94.1072 140.131 88.3941C140.547 82.6811 140.572 79.2867 140.572 79.2867C140.572 79.2867 136.668 74.3922 136.252 74.1437Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6359_86497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.239 68.5703C135.239 68.5703 134.223 71.369 126.916 79.3878C119.608 87.4066 117.624 95.0569 119.844 102.531",
    stroke: "#1D2527",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.438 65.7773C133.438 65.7773 129.418 69.1075 124.438 74.0962C121.377 77.1844 118.763 80.6856 116.672 84.498",
    stroke: "#1D2527",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.047 69.2441C137.047 69.2441 140.098 74.79 141.761 78.1201C143.424 81.4503 145.37 100.167 139.546 106.835",
    stroke: "#1D2527",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.961 64.667L136.247 74.143",
    stroke: "#1D2527",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M136.252 74.1446C136.252 74.1446 127.646 82.0906 125.246 87.8808C122.846 93.671 124.998 99.7183 126.322 101.458C127.646 103.198 128.465 103.443 128.465 103.443C128.465 103.443 123.913 105.183 120.935 100.631C117.956 96.0796 118.697 90.9452 119.61 87.3879C120.523 83.8307 120.27 73.3989 122.34 69.9231C124.41 66.4472 127.389 63.88 132.356 64.4586C137.324 65.0372 139.968 67.6044 141.541 70.8317C143.114 74.0589 142.368 79.5234 142.865 81.9235C143.362 84.3235 145.514 91.5238 146.011 95.8268C146.508 100.13 140.641 103.194 139.715 103.61C139.086 103.874 138.413 104.02 137.731 104.038C137.731 104.038 139.715 94.1081 140.131 88.3951C140.547 82.6821 140.572 79.2877 140.572 79.2877C140.572 79.2877 136.668 74.3932 136.252 74.1446Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M120.74 79.6914H119.472C118.771 79.6914 118.203 80.2594 118.203 80.96V86.0388C118.203 86.7394 118.771 87.3074 119.472 87.3074H120.74C121.441 87.3074 122.009 86.7394 122.009 86.0388V80.96C122.009 80.2594 121.441 79.6914 120.74 79.6914Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M144.006 79.6914H142.737C142.037 79.6914 141.469 80.2594 141.469 80.96V86.0388C141.469 86.7394 142.037 87.3074 142.737 87.3074H144.006C144.707 87.3074 145.275 86.7394 145.275 86.0388V80.96C145.275 80.2594 144.707 79.6914 144.006 79.6914Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M143.699 79.6907V75.5506C143.699 72.3463 142.426 69.2732 140.16 67.0074C137.895 64.7417 134.822 63.4688 131.617 63.4688C128.413 63.4687 125.339 64.7415 123.073 67.0072C120.806 69.2728 119.532 72.3459 119.531 75.5506V79.6907",
    stroke: "#0E1213",
    strokeWidth: 2.55833,
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M143.372 87.2676C143.372 87.2676 142.836 91.412 137.766 93.1006",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M137.569 92.9218C137.783 93.5432 137.179 94.3147 136.215 94.6361C135.251 94.9576 134.303 94.739 134.072 94.1175C133.84 93.4961 134.462 92.7246 135.422 92.4032C136.382 92.0818 137.368 92.3003 137.569 92.9218Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8263 98.2645L33.1172 106.703L38.2259 156.749H73.5285L78.5215 105.872L61.8796 98.1445L50.8263 98.2645Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9203 113.534C58.2517 113.534 58.5204 113.265 58.5204 112.934C58.5204 112.603 58.2517 112.334 57.9203 112.334C57.589 112.334 57.3203 112.603 57.3203 112.934C57.3203 113.265 57.589 113.534 57.9203 113.534Z",
    fill: "#0E1213"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5204 116.535C58.5204 116.653 58.4852 116.769 58.4192 116.868C58.3533 116.967 58.2596 117.044 58.15 117.089C58.0403 117.134 57.9197 117.146 57.8033 117.123C57.6869 117.1 57.58 117.043 57.4961 116.959C57.4121 116.875 57.355 116.768 57.3318 116.652C57.3087 116.535 57.3206 116.415 57.366 116.305C57.4114 116.195 57.4883 116.102 57.587 116.036C57.6857 115.97 57.8017 115.935 57.9203 115.935C58.0795 115.935 58.2321 115.998 58.3446 116.11C58.4571 116.223 58.5204 116.375 58.5204 116.535Z",
    fill: "#0E1213"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M64.059 100.819L59.2203 106.215L57.1545 111.457L54.9302 106.138L50.25 100.819V91.373H64.059V100.819Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M50.25 95.5732C51.1609 96.6805 52.3061 97.572 53.603 98.1834C54.9 98.7949 56.3164 99.111 57.7502 99.109C60.0644 99.1119 62.3029 98.2846 64.059 96.7775V91.373H50.25V95.5732Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7287 64.9385H56.783C51.9495 64.9385 48.0312 68.8568 48.0312 73.6902V87.7006C48.0312 92.5341 51.9495 96.4524 56.783 96.4524H58.7287C63.5622 96.4524 67.4805 92.5341 67.4805 87.7006V73.6902C67.4805 68.8568 63.5622 64.9385 58.7287 64.9385Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6141 78.9092L59.327 85.7966C59.3214 86.095 59.2242 86.3846 59.0487 86.626C58.8732 86.8675 58.6277 87.0492 58.3455 87.1466C57.8269 87.3052 57.2355 87.1466 56.9141 85.9765",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M54 88.5137H61.7145C61.7145 88.5137 60.3645 91.4538 57.7458 91.4538C55.1272 91.4538 54 88.5137 54 88.5137Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5486 89.5466H61.0459C61.2929 89.2237 61.5082 88.8778 61.6888 88.5137H54C54.1464 88.8761 54.3303 89.2223 54.5486 89.5466Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9087 82.0077C54.2164 82.0077 54.4659 81.4205 54.4659 80.6962C54.4659 79.9719 54.2164 79.3848 53.9087 79.3848C53.601 79.3848 53.3516 79.9719 53.3516 80.6962C53.3516 81.4205 53.601 82.0077 53.9087 82.0077Z",
    fill: "#0E1213"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2368 82.0077C62.5446 82.0077 62.794 81.4205 62.794 80.6962C62.794 79.9719 62.5446 79.3848 62.2368 79.3848C61.9291 79.3848 61.6797 79.9719 61.6797 80.6962C61.6797 81.4205 61.9291 82.0077 62.2368 82.0077Z",
    fill: "#0E1213"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4922 77.2436C60.4922 77.2436 62.3951 76.0521 64.5423 77.9593",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7559 64.9385C55.1767 64.9385 52.7032 65.963 50.8795 67.7867C49.0558 69.6105 48.0312 72.084 48.0312 74.6631V83.5219H48.1127H48.9056V79.8704C48.9056 79.8704 52.8743 79.8704 57.5587 77.3332C62.2431 74.7959 63.426 70.6558 63.426 70.6558C63.426 70.6558 64.4589 75.6574 65.569 76.6089L66.6833 77.5603V83.5948H67.4762V74.6631C67.4762 72.0847 66.4522 69.6119 64.6294 67.7883C62.8066 65.9647 60.3342 64.9396 57.7559 64.9385Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2018 78.833H48.0232V86.0547H46.2018C45.738 86.0547 45.2932 85.8704 44.9653 85.5425C44.6374 85.2146 44.4531 84.7698 44.4531 84.306V80.5731C44.4554 80.1108 44.6406 79.6682 44.9683 79.3421C45.296 79.0161 45.7395 78.833 46.2018 78.833Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1811 86.0547H67.3596V78.833H69.1811C69.4107 78.833 69.6381 78.8783 69.8502 78.9661C70.0624 79.054 70.2551 79.1828 70.4175 79.3452C70.5799 79.5076 70.7087 79.7003 70.7966 79.9125C70.8845 80.1246 70.9297 80.352 70.9297 80.5816V84.3146C70.9274 84.7769 70.7422 85.2195 70.4145 85.5456C70.0868 85.8716 69.6433 86.0547 69.1811 86.0547Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4453 78.8322V74.2249C46.4453 71.2355 47.6329 68.3684 49.7467 66.2546C51.8606 64.1407 54.7276 62.9531 57.7171 62.9531C60.7062 62.9543 63.5726 64.1422 65.6862 66.2558C67.7998 68.3694 68.9878 71.2358 68.9889 74.2249V78.8322",
    stroke: "#0E1213",
    strokeWidth: 2.55833,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9898 86.0547C68.9898 86.0547 68.4326 90.3405 63.1953 92.0892",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9889 91.9002C63.2118 92.5431 62.586 93.3403 61.5917 93.6875C60.5974 94.0346 59.6117 93.7903 59.3888 93.1474C59.1659 92.5046 59.7917 91.7074 60.786 91.3602C61.7803 91.0131 62.7789 91.2574 62.9889 91.9002Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1197 106.703L18.1406 138.397L24.3208 143.789L35.494 129.765L33.1197 106.703Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8846 116.419L35.5233 128.694L31.2031 121.643",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5193 105.871L92.7826 137.728L83.988 141.534L76.1406 128.933L78.5193 105.871Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2184 137.608L39.0546 149.613L35.4887 153.775L16.8281 142.199L18.9711 136.494",
    fill: "#219EBC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2184 137.608L39.0546 149.613L35.4887 153.775L16.8281 142.199L18.9711 136.494",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M36.915 148.902C37.4378 148.619 46.1853 146.523 46.3053 147.595C46.4253 148.666 49.0397 149.853 50.2268 149.853C51.414 149.853 52.6055 148.902 52.8412 150.329C53.0769 151.756 51.774 151.872 50.6983 151.992C49.6225 152.112 45.9453 150.92 45.9453 150.92C45.9453 150.92 42.5166 153.775 41.0722 154.491C39.6279 155.206 37.0307 154.962 36.0792 154.251C35.1278 153.539 33.8249 150.565 36.915 148.902Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9922 147.474C44.9922 147.474 48.3223 146.522 49.0337 146.882C49.7452 147.242 50.1052 154.37 50.1052 154.37C50.1052 154.37 49.7452 155.081 49.0337 154.37C48.3223 153.658 45.9479 148.288 45.9479 148.288",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9922 147.474C44.9922 147.474 48.3223 146.522 49.0337 146.882C49.7452 147.242 50.1052 154.37 50.1052 154.37C50.1052 154.37 49.7452 155.081 49.0337 154.37C48.3223 153.658 45.9479 148.288 45.9479 148.288",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3351 147.715C43.3351 147.715 46.7638 146.883 47.4924 148.19C48.221 149.498 49.991 155.322 48.5638 155.558C47.1367 155.794 46.6609 153.895 46.6609 153.895L44.4023 149.733L42.8594 149.498",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3351 147.715C43.3351 147.715 46.7638 146.883 47.4924 148.19C48.221 149.498 49.991 155.322 48.5638 155.558C47.1367 155.794 46.6609 153.895 46.6609 153.895L44.4023 149.733L42.8594 149.498",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1406 148.782C42.1406 148.782 43.8078 148.071 44.6393 148.666C45.4707 149.262 49.2766 155.322 48.5608 155.575C47.8451 155.828 46.1822 155.695 45.9465 155.22C45.7107 154.744 42.6164 150.702 42.6164 150.702",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1406 148.782C42.1406 148.782 43.8078 148.071 44.6393 148.666C45.4707 149.262 49.2766 155.322 48.5608 155.575C47.8451 155.828 46.1822 155.695 45.9465 155.22C45.7107 154.744 42.6164 150.702 42.6164 150.702",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9609 150.804C40.9609 150.804 42.5081 149.377 43.3396 149.853C44.171 150.329 47.6254 154.846 46.9054 155.322C46.1854 155.797 45.7139 155.322 45.0025 154.37C44.4933 153.73 43.8926 153.168 43.2196 152.703L41.7924 153.179",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9609 150.804C40.9609 150.804 42.5081 149.377 43.3396 149.853C44.171 150.329 47.6254 154.846 46.9054 155.322C46.1854 155.797 45.7139 155.322 45.0025 154.37C44.4933 153.73 43.8926 153.168 43.2196 152.703L41.7924 153.179",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8306 134.574L74.3047 150.457L79.1477 153.016L93.381 137.934L89.2966 133.412",
    fill: "#219EBC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8306 134.574L74.3047 150.457L79.1477 153.016L93.381 137.934L89.2966 133.412",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0686 148.902C77.5458 148.619 68.794 146.523 68.6783 147.595C68.5626 148.666 65.944 149.853 64.7525 149.853C63.561 149.853 62.3781 148.902 62.1381 150.329C61.8981 151.756 63.2096 151.872 64.281 151.992C65.3525 152.112 69.0341 150.92 69.0341 150.92C69.0341 150.92 72.4627 153.775 73.9071 154.491C75.3514 155.206 77.9486 154.962 78.9001 154.251C79.8515 153.539 81.1587 150.565 78.0686 148.902Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M69.988 147.474C69.988 147.474 66.6579 146.522 65.9465 146.882C65.235 147.242 64.875 154.37 64.875 154.37C64.875 154.37 65.2307 155.081 65.9465 154.37C66.6622 153.658 69.0366 148.288 69.0366 148.288",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M69.988 147.474C69.988 147.474 66.6579 146.522 65.9465 146.882C65.235 147.242 64.875 154.37 64.875 154.37C64.875 154.37 65.2307 155.081 65.9465 154.37C66.6622 153.658 69.0366 148.288 69.0366 148.288",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6533 147.715C71.6533 147.715 68.2246 146.883 67.4917 148.19C66.7588 149.498 64.9974 155.322 66.4245 155.575C67.8517 155.828 68.3232 153.912 68.3232 153.912L70.5818 149.751L72.129 149.515",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6533 147.715C71.6533 147.715 68.2246 146.883 67.4917 148.19C66.7588 149.498 64.9974 155.322 66.4245 155.575C67.8517 155.828 68.3232 153.912 68.3232 153.912L70.5818 149.751L72.129 149.515",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8536 148.782C72.8536 148.782 71.1907 148.071 70.3592 148.666C69.5277 149.262 65.709 155.322 66.4248 155.575C67.1405 155.828 68.7992 155.695 69.0392 155.22C69.2792 154.744 72.365 150.702 72.365 150.702",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8536 148.782C72.8536 148.782 71.1907 148.071 70.3592 148.666C69.5277 149.262 65.709 155.322 66.4248 155.575C67.1405 155.828 68.7992 155.695 69.0392 155.22C69.2792 154.744 72.365 150.702 72.365 150.702",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0269 150.804C74.0269 150.804 72.4797 149.377 71.6482 149.853C70.8168 150.329 67.3624 154.846 68.0824 155.322C68.8024 155.797 69.2696 155.322 69.9853 154.37C70.4945 153.73 71.0953 153.168 71.7682 152.703L73.1954 153.179",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0269 150.804C74.0269 150.804 72.4797 149.377 71.6482 149.853C70.8168 150.329 67.3624 154.846 68.0824 155.322C68.8024 155.797 69.2696 155.322 69.9853 154.37C70.4945 153.73 71.0953 153.168 71.7682 152.703L73.1954 153.179",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M100.567 46.8037H72.709C71.4174 46.8037 70.1785 47.3165 69.2648 48.2295C68.3511 49.1424 67.8371 50.3808 67.836 51.6724V59.8156C67.8326 60.4569 67.9559 61.0927 68.1987 61.6863C68.4416 62.2799 68.7992 62.8198 69.2511 63.2749C69.7031 63.73 70.2404 64.0914 70.8323 64.3385C71.4242 64.5855 72.0591 64.7132 72.7005 64.7143H76.1291L71.4533 70.8302L81.9665 64.7143H100.567C101.207 64.7126 101.84 64.5849 102.431 64.3384C103.021 64.092 103.558 63.7316 104.009 63.2779C104.46 62.8242 104.818 62.2861 105.061 61.6942C105.305 61.1024 105.429 60.4684 105.427 59.8284V51.6853C105.43 50.3936 104.919 49.1539 104.008 48.2386C103.096 47.3232 101.859 46.8071 100.567 46.8037Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8106 56.318C82.8114 56.5428 82.7455 56.7628 82.6212 56.9501C82.497 57.1375 82.3199 57.2837 82.1124 57.3703C81.905 57.457 81.6765 57.4801 81.4559 57.4367C81.2353 57.3934 81.0325 57.2856 80.8732 57.1269C80.714 56.9682 80.6054 56.7659 80.5612 56.5454C80.517 56.325 80.5393 56.0964 80.6251 55.8886C80.7109 55.6809 80.8565 55.5032 81.0434 55.3782C81.2302 55.2532 81.45 55.1865 81.6748 55.1865C81.9753 55.1865 82.2635 55.3056 82.4764 55.5177C82.6893 55.7297 82.8094 56.0175 82.8106 56.318Z",
    fill: "#0E1213"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7715 56.318C87.7723 56.543 87.7063 56.7632 87.5819 56.9506C87.4574 57.138 87.2801 57.2843 87.0724 57.3708C86.8647 57.4572 86.6359 57.4801 86.4152 57.4364C86.1945 57.3927 85.9918 57.2845 85.8327 57.1254C85.6736 56.9663 85.5653 56.7635 85.5216 56.5428C85.4779 56.3221 85.5008 56.0934 85.5873 55.8857C85.6738 55.678 85.82 55.5006 86.0074 55.3761C86.1949 55.2517 86.415 55.1857 86.64 55.1865C86.9401 55.1865 87.2279 55.3057 87.4401 55.5179C87.6523 55.7301 87.7715 56.0179 87.7715 56.318Z",
    fill: "#0E1213"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7161 56.318C92.7161 56.5418 92.6497 56.7605 92.5254 56.9466C92.401 57.1327 92.2243 57.2777 92.0176 57.3633C91.8108 57.449 91.5833 57.4714 91.3639 57.4277C91.1444 57.3841 90.9428 57.2763 90.7845 57.1181C90.6263 56.9598 90.5185 56.7582 90.4749 56.5387C90.4312 56.3192 90.4536 56.0917 90.5393 55.885C90.6249 55.6782 90.7699 55.5015 90.956 55.3772C91.1421 55.2529 91.3608 55.1865 91.5846 55.1865C91.8847 55.1865 92.1725 55.3057 92.3847 55.5179C92.5969 55.7301 92.7161 56.0179 92.7161 56.318Z",
    fill: "#0E1213"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M157.481 155.46H105.562V157.556H157.481V155.46Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M165.457 155.46H120.203V157.556H165.457V155.46Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M166.335 151.736H123.039L127.706 118.679H171.002L166.335 151.736Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M168.132 151.736H124.836L129.503 118.679H172.799L168.132 151.736Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M154.856 136.37L159.202 157.551H148.029L143.688 136.37H154.856ZM147.279 142.657C147.3 142.744 147.35 142.82 147.42 142.874C147.49 142.929 147.576 142.958 147.665 142.957L153.995 142.897C154.054 142.897 154.113 142.882 154.166 142.856C154.219 142.829 154.265 142.791 154.301 142.744C154.338 142.697 154.363 142.643 154.375 142.585C154.387 142.527 154.386 142.466 154.372 142.409L153.802 140.035C153.781 139.948 153.732 139.871 153.662 139.816C153.592 139.761 153.505 139.731 153.416 139.73L147.086 139.79C147.027 139.791 146.968 139.806 146.915 139.832C146.862 139.859 146.815 139.897 146.779 139.943C146.742 139.99 146.717 140.045 146.704 140.103C146.691 140.161 146.691 140.221 146.705 140.279L147.279 142.657Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6845 155.46H28.7656V157.556H80.6845V155.46Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6606 155.46H43.4062V157.556H88.6606V155.46Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5379 151.736H46.2422L50.9095 118.679H94.2052L89.5379 151.736Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3348 151.736H48.0391L52.7064 118.679H96.0021L91.3348 151.736Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0638 136.37L82.4054 157.551H71.2322L66.8906 136.37H78.0638ZM70.4822 142.657C70.5041 142.743 70.5538 142.819 70.6237 142.874C70.6935 142.928 70.7794 142.957 70.8679 142.957L77.1981 142.897C77.2575 142.896 77.316 142.882 77.3691 142.856C77.4223 142.829 77.4689 142.791 77.5055 142.744C77.542 142.697 77.5676 142.643 77.5805 142.585C77.5933 142.527 77.593 142.467 77.5795 142.409L77.0052 140.035C76.9849 139.948 76.9356 139.87 76.8656 139.815C76.7955 139.76 76.7088 139.73 76.6195 139.73L70.2893 139.79C70.23 139.791 70.1716 139.805 70.1186 139.832C70.0655 139.858 70.0191 139.897 69.9829 139.944C69.9466 139.991 69.9214 140.045 69.9092 140.103C69.897 140.161 69.898 140.221 69.9122 140.279L70.4822 142.657Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M186.749 157.552H2.0625V159.626H186.749V157.552Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6359_86497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.292,
    height: 166.291,
    fill: "white",
    transform: "translate(0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyonWhatsapp2);
export default __webpack_public_path__ + "static/media/buyonWhatsapp2.1a84971f3ac68bfba91270f3168f1be5.svg";
export { ForwardRef as ReactComponent };